import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaYoutube, FaSpotify, FaSoundcloud } from 'react-icons/fa';
import './Footer.css';

// Beatport Icon Component - Official logo
const BeatportIcon = () => (
  <img 
    src="/images/beatport-logo.svg" 
    alt="Beatport"
  />
);

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const socialLinks = [
    {
      icon: <FaInstagram />,
      url: 'https://www.instagram.com/levitskiy_sergey_',
      label: 'Instagram'
    },
    {
      icon: <FaFacebook />,
      url: 'https://www.facebook.com/sergeylevitskiydj',
      label: 'Facebook'
    },
    {
      icon: <BeatportIcon />,
      url: 'https://www.beatport.com/artist/sergey-levitskiy/949474',
      label: 'Beatport'
    },
    {
      icon: <FaYoutube />,
      url: 'https://www.youtube.com/@sergeylevitskiy4865',
      label: 'YouTube'
    },
    {
      icon: <FaSpotify />,
      url: 'https://open.spotify.com/artist/1zuBTw0a7yw9fdmnvA4RAi',
      label: 'Spotify'
    },
    {
      icon: <FaSoundcloud />,
      url: 'https://soundcloud.com/sergey-levitskiy',
      label: 'SoundCloud'
    }
  ];

  // Не показываем footer на splash screen
  if (location.pathname === '/splash') {
    return null;
  }

  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      key={location.pathname} // Переанимация при смене страницы
    >
      <div className="footer-content">
        {/* Social Media Icons */}
        <div className="social-icons">
          {socialLinks.map((social, index) => (
            <motion.a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label={social.label}
              whileHover={{ scale: 1.2, y: -5 }}
              whileTap={{ scale: 0.9 }}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05, duration: 0.2 }}
            >
              {social.icon}
            </motion.a>
          ))}
        </div>

        {/* Copyright */}
        <div className="footer-text">
          <p 
            className="copyright admin-trigger"
            onDoubleClick={() => {
              navigate('/admin');
            }}
            style={{ cursor: 'pointer' }}
          >
            © 2026 Sergey Levitskiy. All rights reserved.
          </p>
          <a 
            href="https://www.madebyrsln.com"
            target="_blank"
            rel="noopener noreferrer"
            className="designer"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            Made by RSLN
          </a>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;

